/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVolumeLow: {
  name: 'volume-low';
  data: string;
} = {
  name: 'volume-low',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 3a.5.5 0 0 0-.757-.429L3.98 5.43a.5.5 0 0 1-.257.071H2A1.5 1.5 0 0 0 .5 7v2A1.5 1.5 0 0 0 2 10.5h1.723a.5.5 0 0 1 .257.071l4.763 2.858A.5.5 0 0 0 9.5 13V3ZM4.495 6.286 8.5 3.883v8.234L4.495 9.714a1.5 1.5 0 0 0-.772-.214H2a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h1.723a1.5 1.5 0 0 0 .772-.214ZM11 5.5a.5.5 0 0 0 0 1 1.5 1.5 0 0 1 0 3 .5.5 0 0 0 0 1 2.5 2.5 0 0 0 0-5Z" fill="currentColor"/></svg>`,
};
